import { render, staticRenderFns } from "./RecommendedView.vue?vue&type=template&id=0707abc2&scoped=true"
import script from "./RecommendedView.vue?vue&type=script&lang=js"
export * from "./RecommendedView.vue?vue&type=script&lang=js"
import style0 from "./RecommendedView.vue?vue&type=style&index=0&id=0707abc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0707abc2",
  null
  
)

export default component.exports